// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SET_ACTIVE_ITEM = 'menu/SET_ACTIVE_ITEM';
export const SET_ALERTED_ITEM = 'menu/SET_ALERTED_ITEM';
export const TOGGLE_GROUP = 'menu/TOGGLE_GROUP';
